/* ==========================================================
   MENU SUPERIOR CUSTOMIZADO
   ========================================================== */
(function () {
  'use strict';

  var COLLECTION_URL = '/collections/all';

  var MODAL_COPY = {
    sobre: {
      title: 'Sobre Nosotros',
      html: '<p>En <strong>Bella Sirena</strong> diseñamos trajes de baño pensados para realzar tu belleza y darte la máxima comodidad.</p>' +
            '<p>Cada pieza combina elegancia atemporal, materiales premium y un toque femenino para que te sientas segura — en la playa, la alberca o tu próxima escapada.</p>' +
            '<p>Somos una marca creada <em>por y para mujeres</em> que aman sentirse hermosas y poderosas en cada momento.</p>'
    },
    contacto: {
      title: 'Contacto',
      html: '<p>¿Tienes alguna duda o quieres saber más sobre nuestros productos? Escríbenos:</p>' +
            '<p>📧 <strong>Email:</strong> apoyo@bellasirena.shop</p>' +
            '<p>📱 <strong>WhatsApp:</strong> 00 0000 0000</p>' +
            '<p>🕐 <strong>Horario:</strong> Lunes a Viernes, 9:00 a 18:00 hrs</p>' +
            '<p>Responderemos tu mensaje en un máximo de <strong>24 horas hábiles</strong>.</p>'
    }
  };

  function normalize(s) {
    return (s || '').toString().normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().replace(/[^a-z0-9\s]/g, '').trim().replace(/\s+/g, ' ');
  }

  function getLinkText(el) {
    return (el.textContent || '').replace(/[▾▴⌄⌃]/g, '').trim();
  }

  function ensureModal() {
    var modal = document.getElementById('bs-nav-modal');
    if (modal) return modal;
    modal = document.createElement('div');
    modal.id = 'bs-nav-modal';
    modal.className = 'bs-nav-modal';
    modal.setAttribute('hidden', '');
    modal.innerHTML =
      '<div class="bs-nav-modal__backdrop"></div>' +
      '<div class="bs-nav-modal__dialog" role="dialog" aria-modal="true">' +
        '<button type="button" class="bs-nav-modal__close" aria-label="Cerrar">×</button>' +
        '<h3 class="bs-nav-modal__title"></h3>' +
        '<div class="bs-nav-modal__body"></div>' +
      '</div>';
    document.body.appendChild(modal);
    modal.querySelector('.bs-nav-modal__backdrop').addEventListener('click', closeModal);
    modal.querySelector('.bs-nav-modal__close').addEventListener('click', closeModal);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModal(); });
    return modal;
  }

  function openModal(copy) {
    var modal = ensureModal();
    modal.querySelector('.bs-nav-modal__title').textContent = copy.title;
    modal.querySelector('.bs-nav-modal__body').innerHTML = copy.html;
    modal.removeAttribute('hidden');
    void modal.offsetHeight;
    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    var modal = document.getElementById('bs-nav-modal');
    if (!modal) return;
    modal.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(function () { modal.setAttribute('hidden', ''); }, 250);
  }

  function rebuildDropdown(ulEl, items) {
    if (!ulEl) return;
    ulEl.innerHTML = '';
    items.forEach(function (item) {
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = item.href;
      a.textContent = item.label;
      li.appendChild(a);
      ulEl.appendChild(li);
    });
  }

  function customizeNav() {
    var nav = document.querySelector('.bs-main-nav');
    if (!nav) return;
    if (nav.dataset.cnDone === '1') return;
    var lis = nav.querySelectorAll(':scope > ul > li');
    if (!lis.length) return;
    lis.forEach(function (li) {
      var topLink = li.querySelector(':scope > a');
      if (!topLink) return;
      var text = normalize(getLinkText(topLink));
      if (text === 'inicio' || text === 'home') {
        topLink.setAttribute('href', '/');
        topLink.addEventListener('click', function (e) {
          var path = window.location.pathname.replace(/\/$/, '');
          if (path === '' || path === '/') { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); }
        });
      } else if (/^categor(i|í)a/.test(text)) {
        var hasArrow = /[▾▴]/.test(topLink.textContent);
        topLink.textContent = 'CATEGORÍA' + (hasArrow ? ' ▾' : '');
        topLink.setAttribute('href', COLLECTION_URL);
        var dropdown = li.querySelector('ul, .bs-dropdown');
        if (dropdown) rebuildDropdown(dropdown, [{ label: 'HOT SALE México', href: COLLECTION_URL }]);
      } else if (/^cat(a|á)logo/.test(text)) {
        topLink.setAttribute('href', COLLECTION_URL);
        var dropdown2 = li.querySelector('ul, .bs-dropdown');
        if (dropdown2) rebuildDropdown(dropdown2, [{ label: 'Línea Verano', href: COLLECTION_URL }]);
      } else if (text === 'sobre nosotros' || text === 'sobre') {
        topLink.setAttribute('href', '#sobre-nosotros');
        topLink.addEventListener('click', function (e) { e.preventDefault(); openModal(MODAL_COPY.sobre); });
      } else if (text === 'contacto' || text === 'contato') {
        topLink.setAttribute('href', '#contacto');
        topLink.addEventListener('click', function (e) { e.preventDefault(); openModal(MODAL_COPY.contacto); });
      }
    });
    nav.dataset.cnDone = '1';
  }

  function run() { try { customizeNav(); } catch (e) {} }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  [300, 1000, 2500].forEach(function (ms) { setTimeout(run, ms); });
  var observer = new MutationObserver(run);
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
